// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/myclass.css
// module id = 867
// module chunks = 41